const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params];
  } else {
    params = params.map(val => val.id);
  }
  return params;
};

const generatePayloadForObject = item => {
  // For custom attribute actions, preserve the full hash structure {id, value}
  const isCustomAttributeAction =
    item.action_name === 'update_conversation_custom_attributes' ||
    item.action_name === 'update_contact_custom_attributes';

  // For execute_macro actions, preserve the full object structure {id, name, variables}
  const isExecuteMacroAction = item.action_name === 'execute_macro';

  if (isCustomAttributeAction && item.action_params.id) {
    // Keep the full object with id and value for custom attributes
    return item.action_params;
  }

  if (isExecuteMacroAction && item.action_params.id) {
    // Keep the full object with id and variables for macros
    return item.action_params;
  }

  if (item.action_params.id) {
    item.action_params = [item.action_params.id];
  } else {
    item.action_params = [item.action_params];
  }
  return item.action_params;
};

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  let payload = actions.map(item => {
    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      item.action_params = [item.action_params];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
